<div class="app-progress-bar">
  <div class="container">
    <div class="bar"></div>
  </div>
</div>
